import { Component, OnInit } from '@angular/core';
import { AdminMenuService } from '../shared/service/admin-menu.service';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { environment } from 'src/environments/environment';
import { CommonService } from '../shared/service/common.service';
const LOCAL_USER_KEY = "UserName";
declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  menuArr = [];
  headingArr = [];
  subHeadingArr = [];
  busPackagesArr = [];
  isAdmin: boolean = false;
  LocalToken: string = '';
  imageBaseUrl: string = environment.imageBaseUrl;

  constructor(private adminMenuService: AdminMenuService, private router: Router, private commonService: CommonService) {
    setTimeout(() => {
      $('#kesaviNav').classyNav();
    }, 1500);

  }

  ngOnInit() {
    this.busPackagesArr = this.commonService.busPackagesArr;
    this.LocalToken = localStorage.getItem(LOCAL_USER_KEY);
    if (this.LocalToken != null) {
      this.isAdmin = true;
    }
    else {
      this.isAdmin = false;
      this.getMenu();
      this.getHeading();
      this.getSubHeadingMenu();
    }
  }

  searchTour(value: string) {
    this.router.navigate(["allTours/" + value]);
  }

  logOut() {
    this.blockUI.start('Please wait...');
    setTimeout(() => {
      this.blockUI.stop();
    }, 500);
    localStorage.clear();
    this.router.navigate(["home"]);
    location.reload();
  }

  getMenu() {
    this.adminMenuService
      .getMenu()
      .then((result) => {
        this.menuArr = result;
      })
      .catch((err) => console.log(err));
  }

  getHeading() {
    this.adminMenuService
      .getHeading()
      .then((result) => {
        this.headingArr = result;
      })
      .catch((err) => console.log(err));
  }
  getSubHeadingMenu() {
    this.adminMenuService
      .getSubMenuLinks()
      .then((result) => {
        this.subHeadingArr = result;
      })
      .catch((err) => console.log(err));
  }


}
